import DOMPurify from 'dompurify'

// Bug de seguridad real: la implementación anterior no era un sanitizador
// real — solo pelaba atributos `style` con una regex, y encima tenía un
// bypass total ("si el html menciona cdn.drapp.la en cualquier parte,
// devolvelo TAL CUAL") pensado para no tocar imágenes del propio CDN, pero
// que en la práctica dejaba pasar CUALQUIER HTML (incluido <script>,
// onerror=, javascript: en un href) con solo incluir esa palabra en algún
// lado del contenido. Esto se usa en varios lugares vía
// dangerouslySetInnerHTML sobre texto libre cargado por el equipo
// (evoluciones, diagnósticos, notas, drogas de recetas) — cualquiera de
// esos campos era un vector de XSS persistente real.
//
// DOMPurify hace la sanitización real (scripts, event handlers, URIs
// peligrosas, etc.) — ya permite <img src="..."> de cualquier origen sin
// necesidad de ningún bypass. El hook de abajo preserva el comportamiento
// previo de esta función más allá de la seguridad: solo dejar pasar
// color/background-color dentro de un style="" (evita que texto pegado
// desde Word/otro editor rompa el layout con position/font-size/etc.
// absurdos) — ahora aplicado SOBRE contenido ya sanitizado, no en vez de
// sanitizarlo.
DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
  if (data.attrName !== 'style') return
  data.attrValue = data.attrValue
    .split(';')
    .filter(declaration => /^\s*(color|background-color)\s*:/i.test(declaration))
    .join(';')
})

function sanitize(html) {
  try {
    return DOMPurify.sanitize(html)
  } catch {
    return ''
  }
}

export default sanitize
